/**
 * «Qué revisar» con su gravedad: las críticas primero (DEF-039).
 *
 * QA de TEST, 02-oct-2026: un embargo judicial inscrito y una hipoteca
 * ordinaria —que el producto incluso ofrece comprar— llegaban al asesor con el
 * mismo formato y el mismo peso. La especificación asocia «bloqueo, embargo o
 * restricción» a una «Alerta crítica», y quien revisa veinte casos al día no
 * puede tener que leer el texto de cada alerta para descubrir cuál no debía
 * avanzar.
 *
 * El backend manda `alertas_revisar` (`{texto, critica}`, ya ordenadas). Un
 * backend anterior manda solo `alertas_internas`, textos: se muestran como
 * antes, todas normales. Puro, para correrlo en Node (`tests/unit/portal_ts.py`).
 */
import type { AlertaParaRevisar } from './types/portal'

export function alertasParaRevisar(
  revisar?: AlertaParaRevisar[] | null,
  internas?: string[] | null,
): AlertaParaRevisar[] {
  const base = revisar ?? (internas ?? []).map((texto) => ({ texto, critica: false }))
  // `sort` es estable: dentro de cada grupo se respeta el orden del caso.
  return [...base].sort((a, b) => Number(Boolean(b.critica)) - Number(Boolean(a.critica)))
}

export function cuantasCriticas(alertas: AlertaParaRevisar[]): number {
  return alertas.filter((a) => a.critica).length
}
